// @flow
import { createStore, applyMiddleware } from 'redux';
import { autoRehydrate } from 'redux-persist';
import { syncHistoryWithStore } from 'react-router-redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { browserHistory } from 'react-router';
import defaultState from './defaultState';

// import the root reducer
import rootReducer from './reducers/root';
import thunk from 'redux-thunk';

const store = createStore(
  rootReducer,
  defaultState,
  composeWithDevTools(
    applyMiddleware(thunk),
    autoRehydrate()
  )
);

export const history = syncHistoryWithStore(browserHistory, store);

export default store;



// WEBPACK FOOTER //
// ./src/store.js